export default __webpack_public_path__ + "static/media/vinha.9cdb1b8e.png";